import { gql } from "@apollo/client";

const GET_COURSE_INFO = gql`
  query GetCourseInfo($id: ID!) {
    courseDetails(id: $id) {
      id
      title
      courseType
      courseDays
      levelId
    }
  }
`;

export default GET_COURSE_INFO;
